<template lang="html">
  <span>category help</span>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
</style>
